<div class="button-wrapper button-wrapper__square">
    <ng-content></ng-content>
</div>
